import {TechnicalDatasheet} from './technical-datasheet';
import {TechnicalDatasheetType} from './technical-datasheet-type.enum';

export class TuftTechnicalDatasheet extends TechnicalDatasheet {
  private _author: string;
  private _designName: string;
  private _machineQualityName: string;
  private _machineGroupName: string;
  private _instructionUnitSet: string;

  public constructor(id: number, name: string, imageId: string, author: string, designName: string, machineQualityName: string, machineGroupName: string, instructionUnitSet: string) {
    super(id, name, TechnicalDatasheetType.TUFT, imageId);

    this._author = author;
    this._designName = designName;
    this._machineQualityName = machineQualityName;
    this._machineGroupName = machineGroupName;
    this._instructionUnitSet = instructionUnitSet;
  }

  public get author(): string {
    return this._author;
  }

  public get designName(): string {
    return this._designName;
  }

  public get machineQualityName(): string {
    return this._machineQualityName;
  }

  public get machineGroupName(): string {
    return this._machineGroupName;
  }

  public get instructionUnitSet(): string {
    return this._instructionUnitSet;
  }

  public static fromJSON(tuftTechnicalDatasheetJSON: any): TuftTechnicalDatasheet {
    return new TuftTechnicalDatasheet(
      tuftTechnicalDatasheetJSON.id,
      tuftTechnicalDatasheetJSON.name,
      tuftTechnicalDatasheetJSON.previewFileId,
      tuftTechnicalDatasheetJSON.author,
      tuftTechnicalDatasheetJSON.design,
      tuftTechnicalDatasheetJSON.quality,
      tuftTechnicalDatasheetJSON.machineGroup,
      tuftTechnicalDatasheetJSON.instructionUnitSet
    );
  }
}
